import { Const, Definition } from '@rt/shared/src';
import { SharedEnv } from '@rt/shared/src/env';

const c = Const();
const TroppusGcloudEvaProject = c.Gcloud.Organization.folders.righttouch.folders['righttouch-eva'].folders['evaluation-rt-troppus'];
const TroppusGcloudProdProject = c.Gcloud.Organization.folders.righttouch.folders['righttouch-prod'].folders['production-rt-troppus'];

type Var = SharedEnv.Var & {
  Postgres: {
    Host: string;
    Port: number;
  };
  App: {
    Domain: string;
    UploadBucketName: string;
  };
  Api: {
    Domain: string;
    Port: number;
  };
  InternalApi: {
    Domain: string;
    Port: number;
  };
  Vertex: {
    // ActiveGcloud.ProjectId は dev/test では 'dummy' 固定のため、Vertex 呼び出しには使えない。
    // 環境ごとに実際の GCP プロジェクト ID を解決して持つ。
    GcloudProjectId: string;
  };
  Dns: {
    Root: {
      Name: string;
      ZoneId: string;
    };
  };
};

export class ThisEnv extends SharedEnv {
  Var: Var;

  constructor() {
    super();
    this.Var = (
      {
        [Definition.Env.Dev]: {
          ...this.BaseVar,
          Postgres: {
            Host: 'localhost',
            Port: 5432,
          },
          App: {
            Domain: 'http://localhost:5181',
            UploadBucketName: 'eva-troppus-import-files',
          },
          Api: {
            Domain: 'http://localhost:3035',
            Port: 3035,
          },
          InternalApi: {
            Domain: 'http://localhost:3036',
            Port: 3036,
          },
          Vertex: {
            GcloudProjectId: TroppusGcloudEvaProject.id,
          },
          Dns: {
            Root: {
              Name: 'localhost',
              ZoneId: 'not set',
            },
          },
        },
        [Definition.Env.Test]: {
          ...this.BaseVar,
          Postgres: {
            Host: 'localhost',
            Port: 5432,
          },
          App: {
            Domain: 'http://localhost:5181',
            UploadBucketName: 'eva-troppus-import-files',
          },
          Api: {
            Domain: 'http://localhost:3035',
            Port: 3035,
          },
          InternalApi: {
            Domain: 'http://localhost:3036',
            Port: 3036,
          },
          Vertex: {
            GcloudProjectId: TroppusGcloudEvaProject.id,
          },
          Dns: {
            Root: {
              Name: 'localhost',
              ZoneId: 'not set',
            },
          },
        },
        [Definition.Env.Eva]: {
          ...this.BaseVar,
          Postgres: {
            Host: '127.0.0.1',
            Port: 5432,
          },
          App: {
            Domain: `https://${this.BaseVar.QantDomain.base.app}`,
            UploadBucketName: 'eva-troppus-import-files',
          },
          Api: {
            Domain: `https://${this.BaseVar.QantDomain.troppus.api}`,
            Port: 8080,
          },
          InternalApi: {
            Domain: `https://${this.BaseVar.QantDomain.troppus.internalApi}`,
            Port: 8080,
          },
          Vertex: {
            GcloudProjectId: TroppusGcloudEvaProject.id,
          },
          Dns: {
            Root: {
              Name: 'troppus.eva-qant.jp',
              ZoneId: 'Z063178718IEP8M4E6VQU',
            },
          },
        },
        [Definition.Env.Prod]: {
          ...this.BaseVar,
          Postgres: {
            Host: '127.0.0.1',
            Port: 5432,
          },
          App: {
            Domain: `https://${this.BaseVar.QantDomain.base.app}`,
            UploadBucketName: 'prod-troppus-import-files',
          },
          Api: {
            Domain: `https://${this.BaseVar.QantDomain.troppus.api}`,
            Port: 8080,
          },
          InternalApi: {
            Domain: `https://${this.BaseVar.QantDomain.troppus.internalApi}`,
            Port: 8080,
          },
          Vertex: {
            GcloudProjectId: TroppusGcloudProdProject.id,
          },
          Dns: {
            Root: {
              Name: 'troppus.qant.jp',
              ZoneId: 'Z09682753Q2W7QLMS8AVG',
            },
          },
        },
      } as const satisfies { [K in Definition.Env]: Var }
    )[this.Name];
  }

  getResourceName(name = '', env?: Definition.Env): string {
    return super.getResourceName(Definition.System.Troppus, name, env || this.Name);
  }
}

export const Env = new ThisEnv();
